<template>
  <section class="bg-top">
    <div class="container">
      <h1 class="tit">
        <strong>INCELLDERM</strong>
        PRODUCTS
      </h1>
      <p class="desc mt-2">우수한 피부 과학과 <span class="mbr"></span>자연 유래 성분의 만남으로 <span class="mbr"></span><span class="brs"></span>스킨케어 제품의 새로운 시대를 열다</p>
    </div>
  </section>
</template>

<script>

export default {
  name: 'TopArea',
};
</script>

<style lang='scss' scoped>
.bg-top{
  background: #070200 url(~@/assets/images/product/visual.png) no-repeat top;
  padding: 3.5rem 0;
  margin-top: -3.5rem;
  height: 32rem;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: $mobile-size) {
    margin-top: 0;
    background-position-x: 64%;
  }
  .tit{
    font-size: 4.2rem;
    font-weight: 300;
    color: white;
    line-height: 1.2;
    strong{
      font-weight: 500;
      @media (max-width: $mobile-size) {
        display: block; 
      }
    }
  }
  .desc{
    font-size: 1.6rem;
    font-weight: 300;
    color: white;
    line-height: 1.5;
    // span{
    //   display: block;
    // }
  }
}
@media (max-width: $mobile-size) {
  .bg-top{
    padding: 4rem 0;
    background-size: cover;
    .tit{
      font-size: 3.2rem;
      // line-height: 4.2rem;
    }
    .desc{
      font-size: inherit;
      // line-height: 1.8;
    }
  }
}
</style>
